<template>
    <div>
    <el-breadcrumb separator="/" class="bread">
        <el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'roleManager' }">角色管理</el-breadcrumb-item>
        <el-breadcrumb-item>角色资源配置</el-breadcrumb-item>
    </el-breadcrumb>
        <!-- 操作-->
        <!-- 表格分页-->
        <div class="block">

            <el-tree class="menutree"
                     ref="tree"
                     v-loading="loading"
                     element-loading-text="拼命加载中"
                     :data="data2"
                     :props="defaultProps"
                     node-key="id"
                     :default-checked-keys="checked"
                     show-checkbox
                     default-expand-all
                     :expand-on-click-node="false">
            </el-tree>
        </div>

        <el-row>
            <el-col :span="24" style="text-align: center;margin-top: 10px">
                <div class="grid-content bg-purple-dark">
                    <el-button type="success" @click="save">保存</el-button>
                    <el-button @click="clear">重置</el-button>
                    <el-button @click="back">返回</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    /*import  Bootpage from "../page/Bootpage.vue"*/

    export  default{
        data(){
            return {
                data2: [],
                defaultProps: {
                    children: 'children',
                    label: 'name',
                },
                checked:[],
                list:[],
                resourceid:[],
                //参数设置
                loading:false,
                roleId :"",
            }

        },
        created(){
            var params=this.$route.params;
            this.roleId=params.roleId;
            //调用查询函数
            this.getconfig();
        },
        methods: {
            getData(){
                //数据请求
                this.loading = true
                this.$http.get(this.requetHost+'/sys/resource/getTree')
                    .then(response => {
                            if (response.status === 200) {
                                this.data2 = response.body.tree;
                            }else{
                                this.$message({
                                    showClose: true,
                                    message: '树资源加载不正确',
                                    type: 'error'
                                });
                            }
                        this.loading = false;
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        }
                    )
            },
            getconfig(){
                this.checked.length=0,
                this.loading = true
                //异步请求
                this.$http.get(this.requetHost+"/sys/role/roleResourceFind",{params:{"roleId":this.roleId}})
                    .then(response => {
                        if (response.status === 200) {
                            response.body.list.forEach((item) => {
                                this.checked.push(item.resource_id);
                            })
                        }
                        this.getData();
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            save() {
                var checknodes = "";
                var halfchecknodes = "";
                let nodesDOM = this.$refs.tree.$el.querySelectorAll('.el-tree-node');
                let nodesVue = [].map.call(nodesDOM, node => node.__vue__);
                let arr = nodesVue.filter(item => item.indeterminate === true)
                arr.forEach((item) => {
                    halfchecknodes += item.$vnode.key+",";
                })
                this.$refs.tree.getCheckedKeys().forEach((item) =>{
                    checknodes += item+",";
                })
                var params={checkedNodes:halfchecknodes+";"+checknodes,roleId:this.roleId};
                this.$store.dispatch('configResources',params).then((data)=>{
                    debugger;
                    if(data.res==true){
                        this.$message({showClose: true,message: '保存成功',type: 'success'});
                        this.getconfig();
                    }else{
                        this.$message({showClose: true,message: '参数错误',type: 'error'});
                    }
                })
            },
            clear(){
                this.getconfig();
            },
            back(){
                this.$router.push({name:"roleManager"})
            }
        },

        watch: {
            // 如果路由有变化，会再次执行该方法
            '$route': 'getconfig'
        }

    }

</script>
<style>
.block{
    margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// ConfigResource.vue?11a6cbdd